import {InlineNode} from 'substance'

class UnsupportedInlineNode extends InlineNode {}

UnsupportedInlineNode.type = 'unsupportedinlinenode';

UnsupportedInlineNode.schema = {
    attributes: { type: 'object', default: {} },
    xmlContent: {type: 'string', default: ''},
    tagName: 'string',
    tagType: { type: 'string', optional: true}
}

export {UnsupportedInlineNode}
